import { savePayment } from 'store/reservations/actions';
import formatter from './formatter';
import { schema } from './schema';
import {
  multiPaymentsInitialTouched,
  multiPaymentsInitialValues,
} from '@payments/sectionsMethodsPayment/MultiPayments/config';

export const initialTouched = {
  totalPriceRent: true,
  ...multiPaymentsInitialTouched,
};

export const initialValues = {
  totalPriceRent: 0,
  ...multiPaymentsInitialValues,
  needHoldback: true,
};

const config = {
  schema,
  initialTouched,
  initialValues,
  enableReinitialize: true,
  validateOnChange: true,
  validateOnBlur: true,
  alwaysSetTemporalValues: true,
  formatter,
  submitForm: (request) => savePayment({ request }),
  withButtons: true,
  btnSubmitLabel: 'Continuar',
  dialogs: {
    confirmation: {
      title: 'CONFIRMACIÓN DE REGISTRO',
      message:
        'Una vez cargada la información del cliente tendrás que editarlo manualmente\n¿Estás seguro que quieres continuar?',
      actionLabel: 'Sí, continuar',
      cancelLabel: 'Cancelar',
    },
    response: {
      successTitle: '¡BIEN HECHO!',
      errorTitle: '¡UPS! ALGO PASÓ!',
      successMessage:
        'El cliente se agregó de forma exitosa al catálogo, si deseas realizar algún cambio tendrás que buscarlo y editarlo manualmente.',
      errorMessage:
        'Hubo un error mientras procesabamos la información, por favor intenta de nuevo.',
      successLabel: 'Ir a Clientes',
      errorLabel: 'Reintentar',
      cancelLabel: 'Cancelar',
      successPath: '/customers/',
    },
  },
};

export default config;
